// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__SQFGe","form":"styles_form__3VnWF"};